import 'moment';
import 'moment-timezone';

export default (function () {
});



// WEBPACK FOOTER //
// ./resources/js/admin/moment/index.js